import React, {Component} from "react";
import {Button, Paper} from "@material-ui/core";
import {RefreshIcon} from "../../../helpers/Icons";
import {ErrorOutline} from "@mui/icons-material";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error:"", info:"", errorCatch:"" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, info) {
    this.setState({info: info, errorCatch: error})
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{position: "absolute", top: 0, left: 0, zIndex: 2147483647, width: "100%", height: "100dvh", backgroundColor: "#f5fcff", paddingTop:"20%", boxSizing: "border-box"}}>
          <Paper style={{width: "fit-content", margin: "0 auto", padding: "1rem", verticalAlign: "middle", display: "flex", flexDirection:"column", alignItems: "center", gap: "1.5em"}}>
            <div style={{display: "flex", alignItems: "center", gap: "0.5em"}}>
              <ErrorOutline style={{color: "#aa1f1f", fontSize:"2.5rem"}}/>
              <span>Sorry, an error has occurred.</span>
            </div>
            <div>
              Please <Button style={{margin: "0 0.5em"}} variant="contained" color="secondary" onClick={() => window.location.reload()} endIcon={<RefreshIcon/>}>Reload</Button> the page to continue.
            </div>
          </Paper>
        </div>);
      // return <div>
      //   {this.props.fallback}
      //   Error:
      //   {this.state.error.toString()}
      //   Trace:
      //   {this.state.info.componentStack}
      //   Info:
      //   {this.state.info.toString()}
      //   Caught:
      //   {this.state.errorCatch.toString()}
      // </div>;
    }else {
      return this.props.children;
    }
  }
}